/* Стили */
import '../css/style.scss';

/* Скрипты */
import {iosVhFix} from './utils/ios-vh-fix';
import {initModals} from './modules/modals/init-modals';
import {initDynamicAdaptive} from './modules/dynamic-adaptive/init-dynamic-adaptive';
import {Burger} from './modules/burger';


window.addEventListener('DOMContentLoaded', () => {
  iosVhFix();
  initDynamicAdaptive();
  const burger = new Burger();
  burger.init();
  initModals();
  

  // все скрипты должны быть в обработчике 'DOMContentLoaded', но не все в 'load'
  // в load следует добавить скрипты, не участвующие в работе первого экрана
  window.addEventListener('load', () => {
  });
});
